import React from 'react'

function CookiePolicy() {
  return (
    <div style={{borderBottom:"1px solid white"}}>
        <div className='title'>
            <h2>Cookie Policy</h2>
        </div>
        <div className='content-pp' style={{width:"85%", margin:"auto", marginBottom:"10vh"}}>
            <h3 className='heading' style={{fontSize:"xx-large", marginBottom:"5vh"}}>Effective Date: [Date]</h3>
            <p className='heading-content'>
                This Cookie Policy explains how our badminton website ("Website") uses cookies and similar technologies to collect and store information when you visit or interact with the Website. By using the Website, you consent to the use of cookies as described in this policy.
            </p>

            <h2 className='heading'>What are Cookies?</h2>
            <p className='heading-content'>
                Cookies are small text files that are stored on your device (computer, smartphone, or tablet) when you visit a website. They are widely used to make websites work more efficiently and to provide a better browsing experience. Cookies may be temporary (session cookies) or permanent (persistent cookies).
            </p>

            <h2 className='heading'>How We Use Cookies:</h2>
            <h3 className='sub-heading'>Essential Cookies:</h3>
            <p className='heading-content'>
                We use essential cookies that are necessary for the operation of the Website. These cookies enable basic functions such as page navigation, access to secure areas, and form submission. The Website cannot function properly without these cookies.
            </p>

            <h3 className='sub-heading'>Performance and Analytics Cookies:</h3>
            <p className='heading-content'>
                We use performance and analytics cookies to collect information about how visitors use the Website. These cookies help us analyze and improve the performance of the Website, understand which pages are most and least popular, and identify any errors that may occur. The information collected by these cookies is aggregated and anonymous.
            </p>

            <h3 className='sub-heading'>Functionality Cookies:</h3>
            <p className='heading-content'>
                Functionality cookies allow the Website to remember choices you make (such as language preference or region) and provide enhanced, personalized features. These cookies may also be used to remember changes you have made to text size, fonts, and other customizable elements of the Website.
            </p>

            <h3 className='sub-heading'>Advertising Cookies:</h3>
            <p  className='heading-content'>
                We may use advertising cookies to deliver targeted advertisements and measure the effectiveness of our advertising campaigns. These cookies may track your browsing habits across different websites and collect information to provide relevant ads based on your interests.
            </p>

            <h2 className='heading'>Third-Party Cookies:</h2>
            <h3 className='heading-content'>We may allow third-party service providers, such as analytics or advertising companies, to place cookies on the Website. These third parties may use cookies to collect information about your online activities over time and across different websites.</h3>
            <br />
            <h3 className='heading-content'>We do not have control over the cookies used by these third-party providers. We recommend reviewing their respective cookie policies to understand how they collect and process your information.</h3>

            <h2 className='heading'>Managing Cookies:</h2>
            <h3  className='heading-content'>You can control and manage cookies through your browser settings. Most web browsers allow you to refuse, accept, or delete cookies. Please note that if you choose to disable or delete cookies, certain features of the Website may not function properly.</h3>
            <br />
            <h3 className='heading-content'>To learn more about managing cookies, you can visit the help pages of your browser or the following websites:</h3>
            <ul>
                <li><span>For Chrome:</span><a href="https://support.google.com/chrome/answer/95647"> https://support.google.com/chrome/answer/95647</a></li>
                <li><span>For Firefox:</span><a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"> https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences</a></li>
                <li><span>For Safari:</span><a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac"> https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac</a></li>
                <li><span>For Internet Explorer:</span><a href="https://support.microsoft.com/en-us/topic/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"> https://support.microsoft.com/en-us/topic/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d</a></li>
            </ul>

            <h2 className='heading'>Changes to the Cookie Policy:</h2>
            <h3 className='heading-content'>
                We may update this Cookie Policy from time to time. Any changes will be effective upon posting the revised policy on this page. We encourage you to review this Cookie Policy periodically.
            </h3>

            <h2 className='heading'>Contact Us:</h2>
            <h3 className='heading-content'>
                If you have any questions about our Cookie Policy, please contact us at <a href="mailto:chandan1012004@gmail.com">chandan1012004@gmail.com</a>.
            </h3>
        </div>
    </div>
  )
}

export default CookiePolicy
